export default "__VITE_ASSET__hCsC0AQ4__"